import React from 'react'
import styles from './Title.module.scss';

export const Title = ({title, height, aling = 'left', color = 'black'}: any) => {



  return (
    <div className={`subtitle-montserrat text-${aling} text-${color} ${styles.contentTitle}`}>
        <p>{title}</p>
        <div className={`${styles.border} ${aling === 'left' ? styles.alingLeft : styles.alingCenter} `}></div>
    </div>
  )
}
